import { Box, Button, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Routes } from 'constants/routes.constants';
import { useEmbedded } from 'hooks/useEmbedded';

import BorderStack from 'components/@common/BorderStack';
import LinkUnstyled from 'components/@common/LinkUnstyled';
import GenericPageLayout from 'components/@screens/GenericPageLayout';

interface Props {
  /**
   * this onBack prop is specifically used by PageDetailEmbedContainer
   * for embedded dynamic pages
   * to go back to the mobile app's home page rather than the web app's home page
   */
  onBack?: () => void;
}

const Page404 = ({ onBack }: Props) => {
  const { isEmbedded } = useEmbedded();

  return (
    <GenericPageLayout>
      <Typography
        variant="h1"
        sx={{
          color: 'grey.800',
          mb: { xs: 3, md: 5 },
        }}
      >
        404
      </Typography>
      <Box
        sx={{
          flex: { xs: 1, md: 0 },
        }}
      >
        <BorderStack
          sx={{
            py: 3,
            gap: 2,
            mb: { xs: 3, md: 5 },
          }}
        >
          <Typography variant="h6">
            <FormattedMessage id="404.title" />
          </Typography>
          <Typography variant="body2">
            <FormattedMessage id="404.description" />
          </Typography>
        </BorderStack>
      </Box>
      {onBack ? (
        <Button variant="outlined" color="secondary" onClick={onBack} fullWidth>
          <FormattedMessage id="error.back.home.link" />
        </Button>
      ) : (
        !isEmbedded && (
          <Button
            variant="outlined"
            color="secondary"
            component={LinkUnstyled}
            href={Routes.Home}
            fullWidth
          >
            <FormattedMessage id="error.back.home.link" />
          </Button>
        )
      )}
    </GenericPageLayout>
  );
};

export default Page404;
